import { __rest, __assign } from '../../../../../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import { Box, Typography } from '@mui/material';
import { useRisk } from './use.js';
export { useRisks } from './use.js';

var ZigRisk = function (_a) {
    var value = _a.value, _b = _a.width, width = _b === void 0 ? 55 : _b, _c = _a.height, height = _c === void 0 ? 30 : _c, rest = __rest(_a, ["value", "width", "height"]);
    var risk = useRisk(value);
    if (!risk)
        return null;
    var Icon = risk.icon;
    return (React__default.createElement(Box, __assign({ display: "flex", flexDirection: "column", alignItems: "center", gap: "3px" }, rest),
        React__default.createElement(Icon, { width: width, height: height }),
        React__default.createElement(Typography, { variant: "h5", color: risk.color }, risk.label)));
};

export { ZigRisk as default, useRisk };
